/* @flow */
/* eslint-disable react/prop-types */

import * as React from 'react';

export type Props = {
  className?: string,
  columns: React.Element<*>,
  index: number,
  onRowClick?: Function,
  onRowDoubleClick?: Function,
  onRowMouseOut?: Function,
  onRowMouseOver?: Function,
  onRowRightClick?: Function,
  rowData: Object,
  style?: Object,
};

export default class extends React.PureComponent<Props> {
  _rowRef = React.createRef();

  static defaultProps = {
    className: '',
    onRowClick: () => {},
    onRowDoubleClick: () => {},
    onRowMouseOut: () => {},
    onRowMouseOver: () => {},
    onRowRightClick: () => {},
    style: {},
  }

  render() {
    const {
      className,
      columns,
      index,
      onRowClick,
      onRowDoubleClick,
      onRowMouseOut,
      onRowMouseOver,
      onRowRightClick,
      rowData,
      style,
    } = this.props;

    const a11yProps = {};

    // unfocus if focused, helps UX when user has clicked a row.
    if (typeof window !== 'undefined' &&
        this._rowRef.current === window.document.activeElement) {
      this._rowRef.current && this._rowRef.current.blur();
    }

    if (
      onRowClick ||
      onRowDoubleClick ||
      onRowMouseOut ||
      onRowMouseOver ||
      onRowRightClick
    ) {
      a11yProps['aria-label'] = 'row';
      a11yProps.tabIndex = 0;

      if (onRowClick) {
        a11yProps.onClick = event => onRowClick({ event, index, rowData });
      }
      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = event => onRowDoubleClick({ event, index, rowData });
      }
      if (onRowMouseOut) {
        a11yProps.onMouseOut = event => onRowMouseOut({ event, index, rowData });
      }
      if (onRowMouseOver) {
        a11yProps.onMouseOver = event => onRowMouseOver({ event, index, rowData });
      }
      if (onRowRightClick) {
        a11yProps.onContextMenu = event => onRowRightClick({ event, index, rowData });
      }
    }

    return (
      <div
        {...a11yProps}
        ref={this._rowRef}
        className={className}
        role="row"
        style={style}
      >
        {columns}
      </div>
    );
  }
}
